// extracted by mini-css-extract-plugin
export var quantityInput = "_ja-0";